import styled from "styled-components";

export const LinkStyle = styled.span`
  text-decoration: underline;
  cursor: pointer;
`;
